import axios from 'axios';

const BACKEND_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/contact';

export const submitInquiryForm = async (formData) => {
  const payload = {
    name: formData.name,
    email: formData.email,
    location: formData.location,
    howFound: formData.howFound,
    message: formData.message
  };

  const response = await axios.post(BACKEND_API_URL, payload, {
    headers: {
      'Content-Type': 'application/json',
    }
  });

  return response.data;
};
